import { post } from "../../utils/Backend";
import { mockGetSpaceCsEntryConfig } from "./SpaceCustomerServiceMock";

const mock = false;
const BASE = "/lark/app/customerService";

export type SpaceCsEntryConfig = {
  enabled: boolean;
  entryDisplayName: string;
};

export const SpaceCustomerServiceApi = {
  async getSpaceCsEntryConfig(spaceId: string): Promise<SpaceCsEntryConfig> {
    if (mock && false) {
      return mockGetSpaceCsEntryConfig(spaceId);
    }
    const res = await post<
      { spaceId: string },
      { enabled?: boolean; entryDisplayName?: string }
    >(`${BASE}/getSpaceCsEntryEnabled`, { spaceId });
    if (typeof res === "string") {
      return { enabled: false, entryDisplayName: "服务专员" };
    }
    return {
      enabled: res?.enabled !== false,
      entryDisplayName: res?.entryDisplayName?.trim() || "服务专员",
    };
  },

  /** @deprecated 使用 getSpaceCsEntryConfig */
  async getSpaceCsEntryEnabled(spaceId: string): Promise<boolean> {
    const config = await this.getSpaceCsEntryConfig(spaceId);
    return config.enabled;
  },
};
